import StandaloneChart from "./StandaloneChart.js";

export default StandaloneChart;
